import { render, staticRenderFns } from "./deleteSysDocument.vue?vue&type=template&id=12981294"
import script from "./deleteSysDocument.vue?vue&type=script&lang=js"
export * from "./deleteSysDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports